import { Globe2, ShieldCheck } from "lucide-react";

export default function ScrapeModeSelector({ direct, onChange, disabled = false, testId }) {
  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="text-xs text-neutral-400">Verbindungsmodus</div>
      <div className="inline-flex rounded-lg border border-neutral-800 bg-neutral-950 p-1">
        <button type="button" disabled={disabled} onClick={() => onChange(false)} className={`inline-flex items-center gap-2 rounded-md px-3 py-2 text-xs font-medium transition ${!direct ? "bg-neutral-800 text-white" : "text-neutral-500 hover:text-neutral-200"}`}>
          <Globe2 className="h-4 w-4" /> Normal
        </button>
        <button type="button" disabled={disabled} onClick={() => onChange(true)} className={`inline-flex items-center gap-2 rounded-md px-3 py-2 text-xs font-medium transition ${direct ? "bg-[#D32222] text-white" : "text-neutral-500 hover:text-neutral-200"}`}>
          <ShieldCheck className="h-4 w-4" /> Direkt über FlareSolverr
        </button>
      </div>
      <p className="text-[11px] text-neutral-600">{direct ? "Jede Anfrage läuft sofort über FlareSolverr." : "Direkte Anfrage; FlareSolverr nur automatisch bei einer Sperre."}</p>
    </div>
  );
}
